const benefits = [
  {
    title: "Life-Saving Preparedness",
    description: "Ensure first responders have your medical history instantly when every second counts. In emergencies, the first 5 minutes are critical—your QR code can save your life.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    title: "Save Time & Money",
    description: "Instantly share health information in emergencies, reducing critical delays. Split expenses effortlessly with AI receipt scanning—no more manual calculations or spreadsheet hassles.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: "Stay Organized",
    description: "Have your critical health details within reach anywhere, anytime. Track spending patterns, plan recurring bills, and understand your financial future with visual dashboards.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
  },
];

const BenefitsSection = () => {
  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Why OLAID Is Essential For You
          </h2>
          <p className="text-xl text-gray-400">
            Take control of your health and financial information
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="text-center"
            >
              <div className="bg-primary rounded-full p-4 w-16 h-16 mx-auto mb-6 flex items-center justify-center text-white">
                {benefit.icon}
              </div>
              <h3 className="text-xl font-semibold mb-4">
                {benefit.title}
              </h3>
              <p className="text-gray-400">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="max-w-3xl mx-auto bg-secondary rounded-lg p-8">
            <h3 className="text-xl font-semibold mb-4 text-primary-light">Quick Tip</h3>
            <p className="text-gray-300">
              For quick access on the go, add OLAID to your phone's home screen like an app. Simply open app.olaid.me or econ.olaid.me in your browser, tap 'Add to Home Screen,' and you're ready to go!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection; 